export function useKeyboardState() {
  return { keyboardStatus: 'hidden', isKeyboardHidden: true }
}
